import { Navigate, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { LEGAL } from "@/data/legal";

const LINKS = [["mentions-legales", "Mentions légales"], ["confidentialite", "Confidentialité"], ["cgv", "CGV Boutique"]];

export default function LegalPage({ slug }) {
  const d = LEGAL[slug];
  if (!d) return <Navigate to="/" replace />;
  return (
    <div className="pt-28 lg:pt-36" data-testid={`legal-page-${slug}`}>
      <Seo title={`${d.title} | Horsepower Garage`} description={`${d.title} du site Horsepower Garage, réseau national de reprogrammation moteur.`} canonical={`https://www.horsepowergarage.fr/${slug}`} />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-24">
        <div className="flex flex-wrap gap-2 mb-8">
          {LINKS.map(([s, l]) => <Link key={s} to={`/${s}`} className={`px-3 py-1.5 text-xs uppercase tracking-wider font-bold ${s === slug ? "bg-hp-yellow text-black" : "bg-white/5 text-neutral-300 hover:bg-white/10"}`} data-testid={`legal-tab-${s}`}>{l}</Link>)}
        </div>
        <p className="label-eyebrow">Informations légales</p>
        <h1 className="font-display font-black uppercase tracking-tight text-3xl sm:text-5xl mt-2">{d.title}</h1>
        <p className="text-neutral-500 text-sm mt-2">Dernière mise à jour : {d.updated}</p>
        <div className="mt-10 space-y-8">
          {d.sections.map((s, i) => (
            <section key={s.h} className="border-l-2 border-hp-yellow/60 pl-5">
              <h2 className="font-display font-bold uppercase tracking-tight text-xl">{i + 1}. {s.h}</h2>
              {s.p.map((t, j) => <p key={j} className="text-neutral-300 text-sm sm:text-base leading-relaxed mt-3">{t}</p>)}
            </section>
          ))}
        </div>
      </section>
    </div>
  );
}
